import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { EntityStats } from "src/app/models/entityStats";
import { ModuleType } from "src/app/models/enums";
import { GetBrandResponse } from "src/app/models/getBrandResponse";
import { ApiService } from "src/app/services/api/api.service";
import { PopupService } from "src/app/services/shared/popup.service";
import { StateService } from "src/app/services/shared/state.service";

@Component({
  selector: "app-preview-brand-info",
  templateUrl: "./preview-brand-info.component.html",
  styleUrls: ["../entity-info.component.scss"],
})
export class PreviewBrandInfoComponent implements OnInit {
  brandResponse: GetBrandResponse = new GetBrandResponse();
  entityStats: EntityStats = new EntityStats();
  basicInfo: boolean = true;

  @Input() brandId: number = 0;
  @Input() currentRoute: string = "";
  @Input() isPayingUser: boolean = true;

  @Output() dialogClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private apiService: ApiService,
    public stateService: StateService,
    private router: Router,
    private popupService: PopupService,
    private activatedRoute: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    await Promise.all([this.LoadBrandInfo(), this.LoadBrandStats()]);
  }

  private async LoadBrandInfo() {
    const result = await this.apiService.LoadBrandById(
      this.brandId,
      "",
      "",
      this.basicInfo
    );

    if (result?.errorMessage) {
      this.popupService.Notify(result.errorMessage);
      return;
    }

    if (result?.data) {
      this.brandResponse = result.data;
    }
  }

  private async LoadBrandStats() {
    const result = await this.apiService.LoadBrandStats(this.brandId);

    if (result?.errorMessage) {
      this.popupService.Notify(result.errorMessage);
      return;
    }

    if (result?.data) {
      this.entityStats = result.data;
    }
  }

  public OpenSelectedBrand() {
    this.dialogClosed.emit(true);
    const queryParams: NavigationExtras = {
      queryParams: {
        brandId: this.brandId,
        keyword: "",
      },
      //replaceUrl: true,
      relativeTo: this.activatedRoute,
    };

    this.router.navigate(["dashboard/entity-info"], queryParams);
  }
}
